module.exports = __webpack_public_path__ + "img/POL.60ce1d6f.svg";